// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"LoadingSpinner_loadingSpinner__gy92f","spin":"LoadingSpinner_spin__P6UJv","loadingContainer":"LoadingSpinner_loadingContainer__PlctO"};